module.exports = __webpack_public_path__ + "d4ac116d01f62c6602fe8c64f843a46f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg38.jpeg
// module id = 48
// module chunks = 0